import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'kt-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.css']
})
export class PdfViewerComponent implements OnInit {
  @Input() imageType: string;
  @Input() imageContent: SafeResourceUrl;
  constructor(private dialogRef: MatDialogRef<PdfViewerComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  private sanitizer:DomSanitizer) { }

  ngOnInit() {
    this.imageType = this.data.imageType;
    if(this.imageType != 'pdf'){
    this.imageContent = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/'+this.imageType+';base64,'+this.data.imageContent)
  }else{
    this.imageContent = this.data.imageContent.toString();

  }
  }

  public decline() {
    this.dialogRef.close(false);
  }

  public accept() {
    this.dialogRef.close(true);
  }

  public dismiss(type) {
    this.dialogRef.close(false);
  }

}
